<template>
  <div class="template-container">
    <div v-for="survey in surveys" :key="survey.sID" class="list card-container">
      <!-- Needs Approval Button with Icon -->
      <b-button
        v-if="isSurveyAdmin && survey.status === 3"
        class="needs-approval-button needs-approval-icon" 
        @click="openApproval(survey)"
        title="Click here to approve"
        variant="light"
        size="sm"
      >
        <b-icon icon="exclamation-triangle-fill" style="color: #fc7727;" />
      </b-button>

      <div class="w-100">
        <div class="card-head-container align-items-start">
          <div>
            <div class="d-flex justify-content-between align-items-end">
              <h4 class="survey-title" :title="survey.name">{{ survey.name }}</h4>
            </div>
            <div class="d-flex justify-content-between align-items-end">
              <p :title="survey.description" class="list description-container">
                {{ survey.description }}
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center template-buttons">
            <b-button class="template-nav-button btn-default" @click="openPreview(survey)">View</b-button>
            <b-button v-if="isEdit" class="template-nav-button btn-alt" @click="openDelete(survey)">Delete</b-button>
            <b-button v-if="isSelect" class="template-nav-button btn-default" @click="selectItem(survey)">Select</b-button>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-end justify-content-between">
            <div :id="'tag-container-' + survey.sID" :title="survey.tags"
              class="d-flex flex-wrap justify-content-start list tag-button-container">
              <label v-for="(tag, index) in survey.tags" :key="tag" class="tag-button-child">
                {{ tag }}<span v-if="index !== survey.tags.length - 1">,</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListViewSurvey",
  props: {
    surveys: {
      type: Array,
      default: [],
    },
    mode: { // One of "edit" or "select"
      type: String,
      default: "",
    },
    isSurveyAdmin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
    isSelect() {
      return this.mode === "select";
    },
  },
  methods: {
    openApproval(survey) {
      this.$emit("open-approval", survey);
    },
    openPreview(survey) {
      this.$emit("open-preview", survey);
    },
    openDelete(survey) {
      this.$emit("open-delete", survey);
    },
    selectItem(survey) {
      this.$emit("select-item", survey);
    },
  },
};
</script>

<style scoped>
div.template-container {
  justify-content: stretch;
  gap: 1rem 0px !important;
}

.list.card-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: none;
  height: 125px;
  max-height: 150px;
  margin: 0px;
  padding: 1rem 2rem;
  background-color: white;
  border-radius: 30px;
  position: relative;
}

.list.description-container {
  display: -webkit-box;
  overflow: hidden;
  max-height: 1.5rem;
  color: lightgray !important;
  font-style: italic !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.list.tag-button-container {
  overflow-y: clip;
  width: 80%;
  max-height: 40px;
}

.tag-button-child {
  margin: 0px 2px;
}

.needs-approval-button {
  position: absolute;
  top: 10px;
  right: 35px;
  background-color: transparent;
  color: #fc7727;
  border: none;
  box-shadow: none;
  font-size: 2rem; /* Icon size */
  padding: 0;
  cursor: pointer;
}

.needs-approval-button:hover {
  color: #ff8e4d !important;
}

.template-nav-button {
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

.template-nav-button:first-child {
  margin-right: 8px;
}

.btn-default {
  background-color: #fc7727 !important;
  border: none;
}

.btn-default:hover {
  background-color: #ff8e4d !important;
}

.btn-alt {
  background: #DB3360 !important;
  border: none;
}

button.btn-alt:hover {
  background: #DB3360 !important;
}

.template-buttons {
  position: absolute;
  bottom: 15px; /* Set distance from the bottom of the card */
  right: 20px;  /* Set distance from the right of the card */
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/survey-dashboard/survey-views/ListViewSurvey.vue